/**
 * @param {number} timeOffset timezone offset in minutes
 * @returns an ISO Date compatible time offset
 */
export const getIsoOffset = (timeOffset) => {
  const sign = timeOffset < 0 ? "-" : "+";
  const hours = Math.abs(timeOffset / 60) >>> 0;
  const paddedHours = hours.toString().padStart(2, "0");
  const minutes = Math.abs(timeOffset) % 60;
  const paddedminutes = minutes.toString().padStart(2, "0");

  return `${sign}${paddedHours}${paddedminutes}`;
};
